import { SaltWaterDisposalFacilityBase } from './base/salt-water-disposal-facility-base';

export class SaltWaterDisposalFacility extends SaltWaterDisposalFacilityBase { }